import { render, staticRenderFns } from "./airList.vue?vue&type=template&id=4ca05797&scoped=true&"
import script from "./airList.vue?vue&type=script&lang=js&"
export * from "./airList.vue?vue&type=script&lang=js&"
import style0 from "./airList.vue?vue&type=style&index=0&id=4ca05797&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca05797",
  null
  
)

export default component.exports